import React from 'react';
import styled from 'styled-components';
import { Splide, SplideSlide } from '@splidejs/react-splide';
import { CircleTick } from 'assets/common_svgs';

/**
 * Renders a <SimilarStockItemsCarousel/> component
 * @param props
 * @param props.similarStockItems - Array items to be rendered
 * @param props.isProductDetail - Bool to check for product detail page (TODO)
 */

const SimilarStockItemsCarousel = ({
  handleUnit,
  similarStockItems,
  isProductDetail,
  loadingPrices,
  vatExclusive,
  prices,
}) => {
  // TODO: add in pricing function once it is in master!
  const getPrice = (ve, p) => {
    let prodPrice;

    if (prices) {
      prodPrice = prices[p];
    }

    const {
      price,
      price_inclusive: priceInclusive,
      per_pack: perPack,
      unit,
    } = prodPrice;

    return prodPrice ? (
      <>
        <span className="fw-700 fs-20 ff-rc">
          £{ve ? price.toFixed(2) : priceInclusive.toFixed(2)}
        </span>{' '}
        for {perPack}
        {handleUnit(unit) || ''}
      </>
    ) : null;
  };

  return (
    <Splide
      hasTrack={false}
      className="splide"
      role="group"
      aria-label="product image carousel">
      <div className="splide__track">
        <ul className="splide__list">
          {similarStockItems.map(
            (
              { id, description, image, partCode, stockCode, stock, slug },
              i,
            ) => (
              <SplideSlide
                className={`splide__slide splide__slide--${i} p-20`}
                key={id}
                data-testid="splide__slide--similarstock-item">
                <ImageContainer>
                  <a href={`/catalogue/products/${slug}`}>
                    <img src={image} alt="" width="" height="" />
                  </a>
                </ImageContainer>
                <p>
                  <a
                    href={`/catalogue/products/${slug}`}
                    className="fw-700 fs-14 ff-rc splide__slide--similarstock-description"
                    data-testid="splide__slide--similarstock-description">
                    {description}
                  </a>
                </p>
                {!isProductDetail && (
                  <>
                    <p>Part Code: {partCode}</p>
                    <p>Stock Code: {stockCode}</p>
                  </>
                )}
                {/* TODO: add in <ProductPricing /> when it is in master */}
                {loadingPrices ? (
                  <div className="fl collection-product__loading-container">
                    <div className="loader" />
                    <p>Loading Prices</p>
                  </div>
                ) : (
                  <p className="fs-13 nm" data-testid="similarstock-price">
                    {getPrice(vatExclusive, id)}
                  </p>
                )}
                <p
                  className="fs-14 fl"
                  data-testid="splide__slide--similarstock-stock">
                  <CircleTick
                    fillColorMain="#207600"
                    fillColorSecondary="#ffffff"
                  />
                  <StockSpan>{stock}</StockSpan> in stock
                </p>
                <p>
                  <a
                    href={`/catalogue/products/${slug}`}
                    className="fs-14 splide__slide--similarstock-product-link">
                    Click here to view this product, you can then add it to your
                    basket.
                  </a>
                </p>
              </SplideSlide>
            ),
          )}
        </ul>
      </div>
    </Splide>
  );
};

const ImageContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 1rem;
`;

const StockSpan = styled.span`
  color: #207600;
  margin-left: 3px;
  margin-right: 3px;
  font-weight: 700;
`;

export default SimilarStockItemsCarousel;
